import { startFeatureSync } from './lib/features'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerServiceWorker } from './lib/push'
import { initSentry } from './lib/sentry'

initSentry()

startFeatureSync()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Register the push service worker up front so it's ready if the user opts
// into notifications in Settings. No-op when unsupported or VITE_VAPID_PUBLIC_KEY
// is unset.
void registerServiceWorker()
